export const api = {
    endpoints: {
        application_submit_url: '/applicant/add',
        get_property_url: '/property/applicant-option',
        upload_documenmts_url: '/applicant/upload-documents'
    }
};
